module.exports = __webpack_public_path__ + "assets/Space-suit.7f77218b.svg";